export interface LoggingModel {
	logLevel: string;
	body: string;
	title: string;
	dateTime: string;
}
